import script from "./Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Main.vue?vue&type=script&setup=true&lang=js"

import "./Main.vue?vue&type=style&index=0&id=ebbe0f00&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebbe0f00"]])

export default __exports__